/**
 * "Apontamentos do dia" — o que os gestores registraram hoje no Mapa, em
 * tabela, para o PPCP passar para a planilha (plano §P1: a planilha continua
 * sendo digitada pelo PPCP; o Mapa devolve as datas prontas).
 *
 * Entra o que aconteceu na produção (ambiente, peça, tarefa). Cadastro de
 * sala, posto e colaborador fica fora: não vira data na planilha.
 */
import { dataLocalDe } from "../../../utils/dinheiro";
import { descreverTipoDeEvento } from "./timeline";

/** Teto do `limite` do GET /eventos (backend `eventos.LIMITE_MAXIMO`). */
export const LIMITE_DE_EVENTOS = 500;

const CATEGORIA_CADASTRO = "cadastro";

export const COLUNAS_APONTAMENTOS = Object.freeze([
  { key: "hora", label: "Hora" },
  { key: "setor", label: "Setor" },
  { key: "ambiente", label: "Ambiente" },
  { key: "evento", label: "Evento" },
  { key: "detalhe", label: "Detalhe" },
  { key: "quem", label: "Quem" },
]);

/** Meia-noite LOCAL de `hoje`, em ISO — o `desde` do GET /eventos. */
export function inicioDoDia(hoje) {
  const meiaNoite = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  return meiaNoite.toISOString();
}

const DUAS_CASAS = (n) => String(n).padStart(2, "0");

function horaLocal(iso) {
  const quando = dataLocalDe(iso);
  if (!quando || Number.isNaN(quando.getTime())) return "";
  return `${DUAS_CASAS(quando.getHours())}:${DUAS_CASAS(quando.getMinutes())}`;
}

const instante = (evento) => Date.parse(evento.criado_em) || 0;

// A chave do ambiente é "PEDIDO:AMBIENTE" (dados/chaves.js).
const ambienteDaChave = (chave) => (chave ? String(chave).replace(":", " · ") : "");

/**
 * Linhas da exportação, da mais antiga para a mais nova (ordem de leitura
 * de quem vai digitar). `nomeDoSetor(id)` vem do catálogo de setores.
 */
export function linhasDosApontamentos(eventos = [], nomeDoSetor = () => "") {
  return eventos
    .map((evento) => ({ evento, tipo: descreverTipoDeEvento(evento.tipo) }))
    .filter(({ tipo }) => tipo.categoria !== CATEGORIA_CADASTRO)
    .sort((a, b) => instante(a.evento) - instante(b.evento))
    .map(({ evento, tipo }) => ({
      hora: horaLocal(evento.criado_em),
      setor: (evento.setor_id && nomeDoSetor(evento.setor_id)) || "",
      ambiente: ambienteDaChave(evento.chave),
      evento: tipo.titulo,
      detalhe: evento.texto || "",
      quem: evento.usuario || "",
    }));
}

/** O backend devolve no máximo `LIMITE_DE_EVENTOS`: cheio = pode ter faltado. */
export const podeTerFaltado = (eventos = []) => eventos.length >= LIMITE_DE_EVENTOS;
